<template>
  <div :class="`${keyboardClass} vkey_${inputName}`"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

import frenchLayout from "simple-keyboard-layouts/build/layouts/french";
import englishLayout from "simple-keyboard-layouts/build/layouts/english";
import germanLayout from "simple-keyboard-layouts/build/layouts/german";
import italianLayout from "simple-keyboard-layouts/build/layouts/italian";

const determineLocaleBasedKeyboardLayout = (lang_name) => {
  switch (lang_name.toLowerCase()) {
    case "English":
      return englishLayout;
    case "German":
      return germanLayout;
    case "Italian":
      return italianLayout;
    case "French":
      return frenchLayout;
    default:
      return englishLayout;
  }
};

// TODO(mushaheedx): Get client's language name for use here.
const keyboardLayout = determineLocaleBasedKeyboardLayout("English");

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String,
    },
    input: {
      type: String,
    },
    inputName: {
      type: String,
      default: "Default",
    },
    keyBoardType: {
      type: String,
      default: "Default",
    },
  },
  data: () => ({
    keyboard: null,
  }),
  mounted() {
    let keyBoardOptions = {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      inputName: this.inputName,
    };

    if (this.keyBoardType == "numeric") {
      keyBoardOptions["layout"] = {
        default: ["1 2 3", "4 5 6", "7 8 9", ". 0 {bksp}", "{close}"],
      };
      keyBoardOptions["mergeDisplay"] = true;
      keyBoardOptions["display"] = {
        "{close}": "Close",
      };
      keyBoardOptions["theme"] =
        "hg-theme-default hg-layout-numeric numeric-theme w-25 mx-auto";
    } else {
      keyBoardOptions["layout"] = {
        default: [
          "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          "{tab} q w e r t y u i o p [ ] \\",
          "{lock} a s d f g h j k l ; ' {enter}",
          "{shift} z x c v b n m , . / {shift}",
          ".com @ {space} {close}",
        ],
        shift: [
          "~ ! @ # $ % ^ &amp; * ( ) _ + {bksp}",
          "{tab} Q W E R T Y U I O P { } |",
          '{lock} A S D F G H J K L : " {enter}',
          "{shift} Z X C V B N M &lt; &gt; ? {shift}",
          ".com @ {space} {close}",
        ],
      };
      keyBoardOptions["mergeDisplay"] = true;
      keyBoardOptions["display"] = {
        "{close}": "Close",
        "{enter}": "Enter",
      };

      keyBoardOptions["buttonTheme"] = [
        {
          class: "closeBtn",
          buttons: "{close}",
        },
      ];
    }

    this.keyboard = new Keyboard(`.vkey_${this.inputName}`, keyBoardOptions);
    this.keyboard.setInput(this.input);
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);
    },
    onKeyPress(button) {
      this.$emit("onKeyPress", button);

      // if(button === "C") {
      //   this.keyboard.clearInput(this.inputName);
      // }

      /**
       * For handling the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle,
      });
    },
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    },
    inputName(inputName) {
      this.keyboard.setOptions({ inputName });
    },
  },
};
</script>

<style>
.hg-theme-default {
  background-color: #e4e4e445;
}

.hg-theme-default .hg-button {
  height: 55px !important;
  /* background: #ffffff !important; */
  color: black !important;
  -webkit-box-shadow: 0 0 3px -1px rgb(0 0 0 / 30%) !important;
  box-shadow: 0 0px 6px -1px rgb(0 0 0 / 30%) !important;
  font-size: 18px;
}

.closeBtn {
  max-width: 275px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIElements/SimpleKeyboard.vue